<template>
    <div class="header">
        <div class="header__inner">
            <div class="logo">
                <img src="@/assets/images/logo.png" alt="">
            </div>
            <h1 class="title">
                Music Maker
                <strong>JAM</strong>
            </h1>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Header',
    };
</script>

<style scoped>

</style>
